// extracted by mini-css-extract-plugin
module.exports = {"footerSection":"FooterSection_footerSection__2yT5A"};